import React from 'react';
import { AddToCartReferType } from '@/constants/track';

import ProductCard from '@/components/common/ProductCard/VerticalItemLine';
import { getDeliveryDate } from '@/utils/common/porder';
import type { FeatureProductProperties } from './type';
import { BaseProductType } from '@/types/product';
import { CmsSsrComponentProps } from '@/types/cms';
import SkuVerticalProductCard from '@/components/common/ProductCard/sku-product/vertical';

interface ProductTwoProps {
  data: Partial<BaseProductType>[];
  properties?: FeatureProductProperties;
  eventKey: string;
  position: number;
  trackingContext?: CmsSsrComponentProps['trackingContext'];
  isPreview?: boolean;
}

const ProductTwo: React.FC<ProductTwoProps> = ({
  data,
  properties,
  eventKey,
  position,
  trackingContext,
  isPreview
}) => {
  const { multiple_product_layout } = properties;

  return (
    <div className="grid grid-cols-2 gap-2 px-2 pt-2 pb-10">
      {data.map((item, index) => {
        return (
          <div key={item.id} className={`${index > 0 && multiple_product_layout === 'steps' ? 'mt-20' : ''}`}>
            <SkuVerticalProductCard
              favoriteClassName="mt-300 mx-300"
              productNameClass="enki-body-sm-medium"
              productNameContainerCls="h-9"
              addCartParams={{
                referType: AddToCartReferType.normal,
                deliveryDate: getDeliveryDate()
              }}
              positionInfoT2={{
                modSecPos: {
                  mod_nm: eventKey,
                  mod_pos: position
                },
                prodPos: index,
                context: {
                  tag_key: item?.entrance_tag?.tag_key,
                  tag_name: item?.entrance_tag?.tag_name,
                  ...trackingContext
                }
              }}
              data={item}
              hideIcon
              showAddBtn={!isPreview}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ProductTwo;
